import './TextInput.css';
import { useState, useRef, useEffect } from 'react';

export default function TextInput({
    onChange = () => null, 
    value = '', 
    labelText = 'Input text label',
    placeholder = '', 
    autoFocus = true
}) {
    const inputId = "TextInput_" + Math.random();
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef(null);

    const handlePlaceholderClick = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    // Проверяем, является ли placeholder JSX объектом
    const isHtmlPlaceholder = typeof placeholder !== 'string';
    const showHtmlPlaceholder = isHtmlPlaceholder && !value && !isFocused;

    return (
        <div className="TextInputWrapper">
            <label className="TextInputLabel" htmlFor={inputId}>
                {labelText}
            </label>
            <br />
            <div className="TextInputContainer">
                <input
                    ref={inputRef}
                    autoFocus={autoFocus}
                    placeholder={isHtmlPlaceholder ? '' : placeholder}
                    className="TextInputField"
                    onChange={onChange}
                    value={value}
                    id={inputId}
                    type="text"
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                />
                
                {showHtmlPlaceholder && (
                    <div
                        className="TextInputHtmlPlaceholder"
                        onClick={handlePlaceholderClick}
                    >
                        {placeholder}
                    </div>
                )}
            </div>
        </div>
    );
}